import React, {PropTypes} from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux'
import {startSubmit, stopSubmit} from 'redux-form';
// LOCAL
import {createClientInvites, resetCreateClientInvitesForm} from './actions'
import MainContentNewClient from './MainContentNewClient'
// SHARED
import Navigation from '../core/components/Navigation'

class NewClientContainer extends React.Component {
  constructor(props){
    super(props)
  }

  handleNewClientFormSubmit(values){
    const { dispatch } = this.props

    dispatch(createClientInvites(values));
  }

  handleCreateClientInvitesFormReset(){
    const { dispatch } = this.props

    dispatch(resetCreateClientInvitesForm());
  }


  render() {
    const { user, ui } = this.props
    return (

      <MainContentNewClient
        user={user}
        ui={ui}
        onCreateClientInvitesFormReset={this.handleCreateClientInvitesFormReset.bind(this)}
        onNewClientFormSubmit={this.handleNewClientFormSubmit.bind(this)}
      />

    );
  }
}

NewClientContainer.propTypes = {
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default connect()(NewClientContainer)



// WEBPACK FOOTER //
// ./src/accountants/NewClientContainer.js